import { Guid, Nillable } from '@web/utils';
import { WarehouseReceiptProductDetails } from './warehouse-receipt-product-details';
import { WarehouseReceiptStatus } from '../enums/warehouse-receipt-status';
import { Multimedia } from '@web/shared/module/multimedia';

export class WarehouseReceiptDetails {
  public constructor(
    private data: {
      id: Guid;
      receiptedAt: Date;
      createdAt: Date;
      approvedAt?: Nillable<Date>;
      number: string;
      products: WarehouseReceiptProductDetails[];
      status: WarehouseReceiptStatus;
      comment: Nillable<string>;
      files: Nillable<Multimedia[]>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get receiptedAt(): Date {
    return this.data.receiptedAt;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get approvedAt(): Nillable<Date> {
    return this.data.approvedAt;
  }

  public get number(): string {
    return this.data.number;
  }

  public get products(): WarehouseReceiptProductDetails[] {
    return this.data.products;
  }

  public get comment(): Nillable<string> {
    return this.data.comment;
  }

  public get status(): WarehouseReceiptStatus {
    return this.data.status;
  }

  public get files(): Nillable<Multimedia[]> {
    return this.data.files;
  }
}
